const Press = () => {
  return (
    <section className='py-32 relative'>
      <div className='container mx-auto px-8 max-w-7xl'>
        <h2 className='section-title'>
          Пресса
        </h2>
        <p className='text-xl text-gray-600 dark:text-gray-400 mb-8'>
          Ознакомьтесь с нашими последними пресс-релизами и упоминаниями в СМИ.
        </p>
        <div className='grid grid-cols-1 md:grid-cols-2 gap-8'>
          <div className='glass-card p-6 rounded-2xl'>
            <h3 className='text-2xl font-montserrat font-bold mb-4'>Пресс-релизы</h3>
            <p className='text-gray-600 dark:text-gray-400'>
              Последние новости о наших продуктах и достижениях.
            </p>
          </div>
          <div className='glass-card p-6 rounded-2xl'>
            <h3 className='text-2xl font-montserrat font-bold mb-4'>Медиа</h3>
            <p className='text-gray-600 dark:text-gray-400'>
              Упоминания нашей компании в ведущих изданиях.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Press;
